import { ModalTypes } from 'helper/UiHelper';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../components/Button';
import { useDispatch } from '../../../hooks/react-redux-typed';
import * as fromModalActions from '../../../redux/actions/modal.actions';
import { Description, Heading, Wrapper } from './FolderEmptyState.styled';

type Props = { folderUuid: string };

const FolderEmptyState = ({ folderUuid }: Props) => {
    const dispatch = useDispatch();
    const handleAddPodcastsClick = () => {
        dispatch(fromModalActions.Actions.showModal(ModalTypes.editFolderPodcasts, { folderUuid }));
    };
    return (
        <Wrapper>
            <svg
                width="160"
                height="160"
                viewBox="0 0 160 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M99.0468 80.1331C99.0468 63.4009 91.1319 55 79.9539 55C68.9148 55 61 63.4703 61 80.1331C61 96.8654 68.8454 105.266 79.9539 105.266C91.0625 105.266 99.0468 96.796 99.0468 80.1331ZM87.7299 80.2026C87.7299 91.45 84.6056 95.7546 80.0234 95.7546C75.4411 95.7546 72.2474 91.3111 72.2474 80.0637C72.2474 68.8163 75.3716 64.5117 79.9539 64.5117C84.5362 64.5117 87.7299 68.9551 87.7299 80.2026Z"
                    fill="url(#paint0_linear_1563_35138)"
                />
                <path
                    opacity="0.5"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.8317 32.8803C27.8317 30.092 30.092 27.8317 32.8803 27.8317H44.6602C47.4484 27.8317 49.7087 30.092 49.7087 32.8803C49.7087 35.6685 47.4484 37.9288 44.6602 37.9288H37.9288V44.6602C37.9288 47.4484 35.6685 49.7087 32.8803 49.7087C30.092 49.7087 27.8317 47.4484 27.8317 44.6602V32.8803ZM63.1715 32.8803C63.1715 30.092 65.4318 27.8317 68.2201 27.8317H91.7799C94.5682 27.8317 96.8285 30.092 96.8285 32.8803C96.8285 35.6685 94.5682 37.9288 91.7799 37.9288H68.2201C65.4318 37.9288 63.1715 35.6685 63.1715 32.8803ZM110.291 32.8803C110.291 30.092 112.552 27.8317 115.34 27.8317H127.12C129.908 27.8317 132.168 30.092 132.168 32.8803V44.6602C132.168 47.4484 129.908 49.7087 127.12 49.7087C124.332 49.7087 122.071 47.4484 122.071 44.6602V37.9288H115.34C112.552 37.9288 110.291 35.6685 110.291 32.8803ZM32.8803 63.1715C35.6685 63.1715 37.9288 65.4318 37.9288 68.2201V91.7799C37.9288 94.5682 35.6685 96.8285 32.8803 96.8285C30.092 96.8285 27.8317 94.5682 27.8317 91.7799V68.2201C27.8317 65.4318 30.092 63.1715 32.8803 63.1715ZM127.12 63.1715C129.908 63.1715 132.168 65.4318 132.168 68.2201V91.7799C132.168 94.5682 129.908 96.8285 127.12 96.8285C124.332 96.8285 122.071 94.5682 122.071 91.7799V68.2201C122.071 65.4318 124.332 63.1715 127.12 63.1715ZM32.8803 110.291C35.6685 110.291 37.9288 112.552 37.9288 115.34V122.071H44.6602C47.4484 122.071 49.7087 124.332 49.7087 127.12C49.7087 129.908 47.4484 132.168 44.6602 132.168H32.8803C30.092 132.168 27.8317 129.908 27.8317 127.12V115.34C27.8317 112.552 30.092 110.291 32.8803 110.291ZM127.12 110.291C129.908 110.291 132.168 112.552 132.168 115.34V127.12C132.168 129.908 129.908 132.168 127.12 132.168H115.34C112.552 132.168 110.291 129.908 110.291 127.12C110.291 124.332 112.552 122.071 115.34 122.071H122.071V115.34C122.071 112.552 124.332 110.291 127.12 110.291ZM63.1715 127.12C63.1715 124.332 65.4318 122.071 68.2201 122.071H91.7799C94.5682 122.071 96.8285 124.332 96.8285 127.12C96.8285 129.908 94.5682 132.168 91.7799 132.168H68.2201C65.4318 132.168 63.1715 129.908 63.1715 127.12Z"
                    fill="url(#paint1_linear_1563_35138)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_1563_35138"
                        x1="62.9188"
                        y1="59.2479"
                        x2="103.87"
                        y2="92.786"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#03A9F4" />
                        <stop offset="1" stopColor="#50D0F1" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_1563_35138"
                        x1="33.0938"
                        y1="36.6489"
                        x2="119.527"
                        y2="130.171"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#03A9F4" />
                        <stop offset="1" stopColor="#50D0F1" />
                    </linearGradient>
                </defs>
            </svg>

            <Heading>
                <FormattedMessage id="your-folder-is-empty" />
            </Heading>
            <Description>
                <FormattedMessage id="empty-folder-description" />
            </Description>
            <Button width={200} onClick={handleAddPodcastsClick}>
                <FormattedMessage id="add-podcasts" />
            </Button>
        </Wrapper>
    );
};

export default FolderEmptyState;
